export default __webpack_public_path__ + "static/home-background-xl-e2d2793df396c9141930fd07e55268ea.jpg";